export default "__VITE_PUBLIC_ASSET__aaf66514__"